import { CloseType } from "../../../domain/services/table.service";

export class PaymentIntentDto {
  tableId: number;
  totalPaid: number;
  payment: Payment;
  items?: Item[];
  taxPaid: boolean;
  taxValue: number;
  type: CloseType;
  voucherDiscount?: number;
  fidelityDiscount?: number;
  cashbackApplied?: number;
}

export class Payment {
  name: string;
  nfceType: number;
  customerId?: string;
  tokenSession?: string;
  sessionId?: string;
  correlationId?: string;
  customerEmail?: string;
  cardId?: string;
}

export class Item {
  id: number;
  qty: number;
  overridedValue?: number;
  groupedItemsIds?: number[];
}
